import React from 'react';
import logoUrl from './Logo.svg';

type BrandLogoProps = {
  height?: number; // pixel height of the logo image
  className?: string;
  title?: string; // accessible title
};

/**
 * BrandLogo
 * - Unico punto di utilizzo del logo Grented per header desktop e mobile
 * - Usa un asset in /public/assets per sfruttare l'hosting statico di Vite
 * - Dimensione regolabile via prop height
 */
const BrandLogo: React.FC<BrandLogoProps> = ({ height = 28, className, title = 'Grented' }) => {
  return (
    <img
      src={logoUrl}
      alt={title}
      title={title}
      height={height}
      style={{ display: 'block', height, width: 'auto' }}
      className={className}
    />
  );
};

export default BrandLogo;
